import { render, staticRenderFns } from "./InvoiceDetails.vue?vue&type=template&id=31ddad6c&scoped=true"
import script from "./InvoiceDetails.vue?vue&type=script&lang=js"
export * from "./InvoiceDetails.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDetails.vue?vue&type=style&index=0&id=31ddad6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ddad6c",
  null
  
)

export default component.exports